var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasolineBackwheels2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 91,
    viewBox: "0 0 409 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.428,
    cy: 45.5354,
    r: 39.7674,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 10.6047
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4651,
    cy: 45.5354,
    r: 39.7674,
    fill: "#F1E29E",
    stroke: "black",
    strokeWidth: 10.6047
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.961,
    cy: 45.5354,
    r: 39.7674,
    fill: "black",
    stroke: "#F1E29E",
    strokeWidth: 10.6047
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 45.5354,
    r: 39.7674,
    fill: "#F1E29E",
    stroke: "black",
    strokeWidth: 10.6047
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolineBackwheels2);
export default __webpack_public_path__ + "static/media/gasoline-backwheels2.7d7c3e83d6a2acd61c5390ba51ee9077.svg";
export { ForwardRef as ReactComponent };